import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { users } from './users.reducer';
import classReducer from './class.reducer';
import studentReducer from './student.reducer';
import gameReducer from './game.reducer';
import questionReducer from './question.reducer';
import mediaReducer from './media.reducer';
import adminReducer from './admin.reducer';
import activityReducer from './activity.reducer';
import popupReducer from './popup.reducer';
import admessageReducer from './admessage.reducer';
import blockedwordReducer from './blockedword.reducer';
import chatReducer from './chat.reducer';
import chatmonitoringReducer from './chatmonitoring.reducer';
import chathistoryReducer from './chathistory.reducer';
import fontReducer from './font.reducer';
import organizationReducer from './organization.reducer';

const rootReducer = combineReducers({
  authentication: authentication,
  registration: registration,
  users: users,
  classes: classReducer,
  students: studentReducer,
  games: gameReducer,
  questions: questionReducer,
  medias: mediaReducer,
  admins: adminReducer,
  activities: activityReducer,
  popups: popupReducer,
  admessages: admessageReducer,
  blockedwords: blockedwordReducer,
  chatmessages: chatReducer,
  chatmonitor: chatmonitoringReducer,
  chathistory: chathistoryReducer,
  fonts: fontReducer,
  organization: organizationReducer,
});

export default rootReducer;